import { VNode, DirectiveOptions } from 'vue';

// Searches the address validation component using the data returned by "provide" in "gs-address-validation"
const findAddressValidator = (vnode: VNode) => {
  let current = vnode.componentInstance || vnode.context;
  while (current) {
    const provided = (current as any)._provided;
    if (provided?.addressValidator) {
      return provided.addressValidator;
    }
    current = current.$parent;
  }
  return undefined;
};

const addressValidation: DirectiveOptions = {
  bind(el, binding, vnode) {
    const addressValidator = findAddressValidator(vnode);
    if (!addressValidator) {
      return;
    }

    (el as any).$addressValidationField = binding.value;

    (el as any).$onFocus = () => addressValidator.onFocus(el, (el as any).$addressValidationField);
    (el as any).$onBlur = () => addressValidator.onBlur(el, (el as any).$addressValidationField);
    (el as any).$onKeyDown = (event: KeyboardEvent) => addressValidator.onKeyDown(event, (el as any).$addressValidationField);

    el.addEventListener('focus', (el as any).$onFocus, true);
    el.addEventListener('blur', (el as any).$onBlur, true);
    el.addEventListener('keydown', (el as any).$onKeyDown);
  },
  update(el, binding) {
    if (binding.value !== binding.oldValue) {
      (el as any).$addressValidationField = binding.value;
    }
  },
  unbind(el) {
    el.removeEventListener('focus', (el as any).$onFocus, true);
    el.removeEventListener('blur', (el as any).$onBlur, true);
    el.removeEventListener('keydown', (el as any).$onKeyDown);
  },
};

export default addressValidation;
